module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.propostas.length > 0) ? _c('div', {
    staticClass: "box box-primary roteiro"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingShow),
      expression: "loadingShow"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, _vm._l((_vm.propostas), function(proposta) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-7"
    }, [_c('div', {
      staticClass: "proposta_dados"
    }, [_vm._v(_vm._s(proposta.nome))]), _vm._v(" "), _c('ol', {
      staticClass: "lista"
    }, _vm._l((proposta.passos), function(passo) {
      return _c('li', [_c('span', {
        staticClass: "passo"
      }, [_vm._v(_vm._s(passo.texto))]), _c('span', {
        class: 'situacao ' + passo.situacao_codigo
      }, [_vm._v("\n                  " + _vm._s(passo.situacao) + "\n                  " + _vm._s(_vm._.includes(['concluido', 'cancelado', 'atencao'], passo.situacao_codigo) ? ' em ' : '') + "\n                  " + _vm._s(_vm._f("moment")((passo.situacao_codigo === 'atencao' ? passo.termino : (_vm._.includes(['concluido', 'cancelado'], passo.situacao_codigo) ? passo.termino : '')), 'DD/MM/YYYY')) + "\n\n                  "), (passo.codigo === 'cadastro_entidade' && !(_vm._.includes(['concluido', 'cancelado'], passo.situacao_codigo))) ? _c('a', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            inertia: true,
            arrow: true,
            placement: 'top',
            animation: 'perspective',
            distance: '1',
            size: 'large',
            arrow: true
          }),
          expression: "{ inertia : true, arrow : true,  placement : 'top', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
        }],
        attrs: {
          "href": '/cadastro/entidades/edita/' + _vm.usuarioLogado.entity.id,
          "target": "_blank",
          "title": '<h5>Vá para ´Dados Cadastrais´ e complete o formulário</h5>'
        }
      }, [_c('i', {
        staticClass: "fa fa-external-link"
      })]) : _vm._e(), _vm._v(" "), (passo.codigo === 'proposta' && !(_vm._.includes(['concluido', 'cancelado'], passo.situacao_codigo))) ? _c('a', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            inertia: true,
            arrow: true,
            placement: 'top',
            animation: 'perspective',
            distance: '1',
            size: 'large',
            arrow: true
          }),
          expression: "{ inertia : true, arrow : true,  placement : 'top', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
        }],
        attrs: {
          "href": '/proposta/edita/' + proposta.id,
          "target": "_blank",
          "title": '<h5>Vá para a ´Minhas propostas´ e complete o formulário</h5>'
        }
      }, [_c('i', {
        staticClass: "fa fa-external-link"
      })]) : _vm._e()]), _vm._v(" "), (_vm._.size(passo.info) > 0) ? _c('p', {
        staticClass: "informacao"
      }, [_vm._v(_vm._s(passo.info))]) : _vm._e()])
    }), 0), _vm._v(" "), _c('i', [_vm._v("Atenção: A análise somente será iniciada quando o cadastro da entidade e a proposta forem concluídos")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-5 lista_documentos"
    }, [_c('span', [_vm._v("Documentos para download:")]), _vm._v(" "), (proposta.fk_edital === 3) ? _c('ul', [_c('li', [_c('a', {
      attrs: {
        "href": _vm.urlLaravel + '/docs/roteiro_voluntariado_2020_v1.pdf'
      }
    }, [_vm._v("Roteiro para preenchimento da proposta  "), _c('i', {
      staticClass: "fa fa-download",
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), _c('li', [_c('a', {
      attrs: {
        "href": _vm.urlLaravel + '/docs/memoria_calculo_voluntariado_2020_v1.xls'
      }
    }, [_vm._v("Memória de Cálculo - Voluntariado 2020 "), _c('i', {
      staticClass: "fa fa-download",
      attrs: {
        "aria-hidden": "true"
      }
    })])])]) : _vm._e(), _vm._v(" "), (proposta.fk_edital === 4) ? _c('ul', [_c('li', [_c('a', {
      attrs: {
        "href": _vm.urlLaravel + '/docs/roteiro_pis_2020_v1.pdf'
      }
    }, [_vm._v("Roteiro para preenchimento da proposta "), _c('i', {
      staticClass: "fa fa-download",
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), _c('li', [_c('a', {
      attrs: {
        "href": _vm.urlLaravel + '/docs/memoria_calculo_pis_2020_v1.xls'
      }
    }, [_vm._v("Memória de Cálculo - PIS 2020 "), _c('i', {
      staticClass: "fa fa-download",
      attrs: {
        "aria-hidden": "true"
      }
    })])])]) : _vm._e()])])
  }), 0), _vm._v(" "), _c('g-button-ujarak', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "color": "dark-primary",
      "size": "button--size-ss",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.carregarPropostas()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Atualizar\n  ")])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-map-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Roteiro\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cfb0d5ea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/dashboard/Roteiro.vue
// module id = 2082
// module chunks = 1